module.exports = __webpack_public_path__ + "img/two_circle.bd764a33.svg";